import Ajax from './ajax';

const Request = {
  User: {
    info() {
      return Ajax.get('/account/info');
    }
  },
  Dict: {
    get() {
      return Ajax.get(`/dict`);
    }
  },
  Home: {
    getMessageList() {
      return Ajax.get(`/home/messages`);
    },
    createTodo(param) {
      return Ajax.postJson('/home/messages', param);
    },
    setTodoDone(id, done = true) {
      return Ajax.postJson(`/home/messages/${id}/done`, { done });
    },
    deleteTodo(id) {
      return Ajax.delete(`/home/messages/${id}`);
    },
    restoreTodo(id) {
      return Ajax.postJson(`/home/messages/${id}/restore`, {});
    },
    purgeTodo(id) {
      return Ajax.delete(`/home/messages/${id}/purge`);
    }
  },
  Account: {
    menus() {
      return Ajax.get('/account/menus');
    },
    getRoleConfig(roleId) {
      return Ajax.get(`/management/roles/${roleId}/config`);
    },
    saveRoleConfig(param) {
      return Ajax.postJson('/management/role-config', param);
    },
    changePassword(param) {
      return Ajax.postJson('/account/change-password', param);
    }
  },
  Login: {
    login(param) {
      return Ajax.postJson('/login', param, { repeatable: true, timeout: 15000 });
    },
    logout(param) {
      return Ajax.post('/logout', param);
    }
  },
  Management: {
    users(params) {
      return Ajax.get('/management/users', params);
    },
    roles(params) {
      return Ajax.get('/management/roles', params);
    },
    updateRole(id, param) {
      return Ajax.postJson(`/management/roles/${id}`, param);
    },
    sysUsers() {
      return Ajax.get('/management/sys-users');
    },
    createSysUser(param) {
      return Ajax.postJson('/management/sys-users', param);
    },
    updateSysUser(id, param) {
      return Ajax.postJson(`/management/sys-users/${id}`, param);
    },
    deleteSysUser(id) {
      return Ajax.delete(`/management/sys-users/${id}`);
    },
    setSysUserActive(id, isActive) {
      return Ajax.postJson(`/management/sys-users/${id}/active`, { isActive });
    }
  },
  Access: {
    report(param) {
      return Ajax.postJson('/access-logs', param, { repeatable: true });
    },
    list(params) {
      return Ajax.get('/access-logs', params);
    }
  }
};

export default Request;
